/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { Loader } from 'rsuite';
import Pages from '~/authorization/pages';
import ErrorPage from '~/pages/ErrorPage';
import Login from '~/pages/Login';
import Route from './Route';
import { loginByDashboard } from '~/services/helper';

const DashboardAuthorization = async (location, setLoading) => {
  const loc = location.search.substring(1, location.search.length);
  let token = null;
  let paramName = false;
  const params = loc.split('&');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < params.length; i++) {
    paramName = params[i].substring(0, params[i].indexOf('='));
    // eslint-disable-next-line eqeqeq
    if (paramName == 'dG9rZW5DcmlwdG9ncmFmYWRv') {
      token = params[i].substring(params[i].indexOf('=') + 1);
    }
  }
  token = token?.replaceAll('%3D', '=');

  if (token) {
    const tokenDecrypt = atob(atob(token));
    window.history.replaceState(null, null, window.location.pathname);
    await loginByDashboard(tokenDecrypt, setLoading);
  } else {
    setLoading(false);
  }
};

export default function Routes() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    document.referrer.indexOf('https://orgdashboard.azurewebsites.net') !== -1
      ? DashboardAuthorization(window.location, setLoading)
      : setLoading(false);
  }, []);
  return !loading ? (
    <Switch>
      <Route path="/login" exact component={Login} />

      {Pages.map((page) => (
        <Route
          key={page.name}
          path={page.route}
          component={page.component}
          isPrivate
          exact
        />
      ))}

      <Route path="/error" component={ErrorPage} exact isPrivate />
      <Redirect from="*" to="/error" />
    </Switch>
  ) : (
    <div className="overlay">
      <Loader backdrop vertical size="lg" />
    </div>
  );
}
